import { supabase } from '@/lib/supabase/client';

export function getSupabase() {
  // Kids tables are introduced by the Kids migrations and are not yet in
  // the generated production Database type. Keep one shared runtime client
  // while using an untyped boundary for the Kids feature until types are
  // regenerated from the migrated project.
  return supabase as any;
}
